import { i18n } from "@/i18n";
import { datadogRum } from "@datadog/browser-rum";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueIntercom from "vue-intercom";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import App from "./App.vue";
import "./extensions";
import "./globalComponentRegistration";
import router from "./router";
import { Mixpanel } from "./service/analytics/mixpanel";
import store from "./store";
Vue.use(VueIntercom, { appId: process.env.VUE_APP_PeakIntercom });

Vue.use(vClickOutside);

Vue.component("multiselect", Multiselect);

Vue.use(VueClipboard);

Vue.use(Croppa);

router.beforeEach((to, from, next) => {
  next();
});

router.onError((error) => {
  const regex = new RegExp(/Loading .* failed\./i);
  if (regex.test(error.message)) {
    window.location.href = `${process.env.VUE_APP_PeakAccount}update.html?v=${new Date().getTime()}`;
  }
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
